<div class="breadcrumb_container">
  @for (stepLabel of stepsLabels; track $index; let i = $index) {
    <button
      (click)="onClick(i)"
      class="breadcrumb_item bold"
      type="button"
      [title]="stepLabel">
      {{ (i === 0) ? (stepLabel | translate) : stepLabel }}
    </button>
  }
</div>
